import * as React from 'react';

export const DEVICE_WIDTH_COOKIE_NAME = 'device-width';

function setDeviceWidth() {
  document.cookie = `${DEVICE_WIDTH_COOKIE_NAME}=${window.innerWidth};path=/;max-age=${60 * 60 * 24 * 365}`;
}

let resizeTimeout: ReturnType<typeof setTimeout>;

/**
 * Resizing the window using dev tools or similar device simulators
 * does not consistently hit the correct timing with the resize listener
 * resulting in an incorrect width unless you debounce it slightly.
 */
function setDeviceWidthDebounced() {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    setDeviceWidth();
  }, 100);
}

export function useSetDeviceWidth() {
  React.useEffect(() => {
    setDeviceWidth();
    window.addEventListener('resize', setDeviceWidthDebounced);
    window.addEventListener('orientationchange', setDeviceWidthDebounced);
    return () => {
      window.removeEventListener('resize', setDeviceWidthDebounced);
      window.removeEventListener('orientationchange', setDeviceWidthDebounced);
    };
  }, []);
}
